// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3l96t","row":"styles_row__1C7zy"};